import PreferencesProgressionConfirmPane from './PreferencesProgressionConfirmPane';

export default PreferencesProgressionConfirmPane;
export { PreferencesProgressionConfirmPane };
